/* Aftabi Salajeet — theme.js
   Lightweight vanilla JS: mobile nav, cart drawer, accordions,
   quantity steppers, product gallery thumbnails. No build step required. */
document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Mobile nav drawer ---------- */
  var mobileToggle = document.querySelector('[data-mobile-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var mobileClose = document.querySelector('[data-mobile-nav-close]');
  var overlay = document.querySelector('[data-overlay]');

  function openMobileNav() {
    if (mobileNav) mobileNav.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    if (mobileNav) mobileNav.classList.remove('is-open');
    if (overlay && !document.querySelector('.cart-drawer.is-open')) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (mobileToggle) mobileToggle.addEventListener('click', openMobileNav);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileNav);

  /* Mobile submenu expand */
  document.querySelectorAll('[data-mobile-submenu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var submenu = btn.nextElementSibling;
      if (!submenu) return;
      var open = submenu.style.display === 'block';
      submenu.style.display = open ? 'none' : 'block';
      btn.classList.toggle('is-open', !open);
    });
  });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartTriggers = document.querySelectorAll('[data-cart-toggle]');
  var cartClose = document.querySelector('[data-cart-close]');

  function openCartDrawer() {
    if (!cartDrawer) { window.location.href = '/cart'; return; }
    cartDrawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (overlay && !mobileNav?.classList.contains('is-open')) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  cartTriggers.forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (cartDrawer) { e.preventDefault(); openCartDrawer(); }
    });
  });
  if (cartClose) cartClose.addEventListener('click', closeCartDrawer);
  if (overlay) overlay.addEventListener('click', function () { closeMobileNav(); closeCartDrawer(); });

  /* ---------- Add to cart via AJAX (updates drawer + count) ---------- */
  document.querySelectorAll('[data-add-to-cart-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!cartDrawer) return; // fall back to normal form submit -> /cart
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.originalText = submitBtn.textContent; submitBtn.textContent = 'Adding…'; }

      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          openCartDrawer();
        })
        .catch(function () { window.location.href = '/cart'; })
        .finally(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.originalText; }
        });
    });
  });

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  /* ---------- Accordion (product info, FAQs) ---------- */
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('.accordion-item');
      if (!item) return;
      var wasOpen = item.classList.contains('is-open');
      var group = item.parentElement;
      if (group && group.dataset.accordionSingle === 'true') {
        group.querySelectorAll('.accordion-item.is-open').forEach(function (openItem) {
          if (openItem !== item) openItem.classList.remove('is-open');
        });
      }
      item.classList.toggle('is-open', !wasOpen);
    });
  });

  /* ---------- Quantity selector ---------- */
  document.querySelectorAll('[data-quantity-selector]').forEach(function (wrap) {
    var input = wrap.querySelector('input[type="number"]');
    var minus = wrap.querySelector('[data-quantity-minus]');
    var plus = wrap.querySelector('[data-quantity-plus]');
    if (minus) minus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
    if (plus) plus.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
  });

  /* ---------- Product gallery thumbnails ---------- */
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main] img');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full-src');
        if (mainImg && src) mainImg.setAttribute('src', src);
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  });

  /* ---------- Header search toggle ---------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPanel = document.querySelector('[data-search-panel]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      searchPanel.classList.toggle('is-open');
      if (searchPanel.classList.contains('is-open')) {
        var input = searchPanel.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  }

  /* ---------- Sticky header shrink on scroll ---------- */
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var lastY = window.scrollY;
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
      lastY = window.scrollY;
    }, { passive: true });
  }
});
